// Components

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';

// Services
import BreedService from '@/app/services/main/breeds/breeds-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
	name: 'BreedsContainer',
	components: {},
	mixins: [
		tableMixins,
		productMixins,
		toastMessageMixins
	],
	computed: {
		selectedBreeds() {
			return this.$store.getters.getSelectedBreeds;
		}
	},
	data() {
		const sizes = [
			{id: 2, name: 'Small'},
			{id: 3, name: 'Medium'},
			{id: 4, name: 'Large'},
		];
		return {
			isAPILoading: false,
			isBreedsLoading: false,
			// table
			theads: [
				{ name: 'Name', searchLabel: 'f_name', sortLabel: 'name', isDesc: false, hasSearch: true, style: null },
				{ name: 'Breed Size', searchLabel: 'f_breedSizeId', sortLabel: 'breedSizeId', isDesc: false, hasDropdownSearch: true, style: null, options: sizes },
				{ name: 'Send Notification', searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false, style: null, hasBtn: true },
				{ name: 'Active Pets', searchLabel: null, sortLabel: 'petCount', isDesc: true, hasSearch: false, style: null },
				{ name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasStatusSearch: true,  style: null },
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false,  style: null }
			],
			// sorting
			desc: true,
			sortBy: 'petCount',
			modalContent: {},
		}
	},
	created() {
		this.getTableContent();
	},
	activated() {
        // this lifecycle method will only be called for components under keep-alive
        this.getTableContent();
	},
	methods: {
		getBreedList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_name) {
					queryParams['f_name'] = this.columnsFilter.f_name;
				}

				if (this.columnsFilter.f_breedSizeId) {
					queryParams['f_breedSizeId'] = this.columnsFilter.f_breedSizeId;
				}

				if (this.columnsFilter.f_status) {
					queryParams['f_status'] = this.columnsFilter.f_status;
				}
			}
			this.isAPILoading = true;
			BreedService.getBreedList(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};
					} else {
						this.showAPIErrorToast('Unable to fetch breeds list.', res);
					}
				})
				.catch(() => {
					this.showGenericErrorToast();
				})
				.finally(() => {
					this.isAPILoading = false;
				});
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
			this.getBreedList({ page, limit, sortBy, desc });
		},
		updateBreedStatus(event, breed) {
			let body = { status : 'ACTIVE' };
			let swalTitle = 'Reactivate Breed';
			let swalText = `Are you sure you want to reactivate ${breed.name}?`;
			let isActivated = 'reactivated';
			// Deactivate breed
			if (!event.target.checked) {
				body.status = 'INACTIVE'
				swalTitle = 'Deactivate Breed';
				swalText = `Are you sure you want to deactivate ${breed.name}?`;
				isActivated = 'deactivated';
			}
			this.$swal({
				title: swalTitle,
				text: swalText,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
					BreedService.updateStatusBreed(breed.id, body)
						.then(res => {
							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(`Successfully ${isActivated}`, `Successfully ${isActivated} ${breed.name}.`);
							} else {
								this.showAPIErrorToast(`Unable to ${isActivated} breed.`, res);
								event.target.checked = !event.target.checked;
							}
						})
						.finally(() => {
							this.isAPILoading = false;
						});
				} else {
					event.target.checked = !event.target.checked;
				}
			});
		},
		deleteBreed(breed) {
			const { name, id } = breed;
			// show modal confirmation
			this.$swal({
				title: `Are you sure you want to delete ${name}?`,
				text: `You won't be able to revert this action.`,
				confirmButtonText: 'Delete',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#dd3333 !important',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
					// API call for delete
					BreedService.deleteBreed(id).then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast('Deleted!', `${name} has been deleted!`);
							// refresh table with filter
							this.getTableContent();
						} else {
							this.showAPIErrorToast(`Unable to delete ${name}`, res);
						}
					});
				}
			});
		},
		markBreedForNotification(event, breed) {
			if (event.target.checked) {
				this.$store.commit('setSelectedBreeds', breed);
			} else {
				this.$store.commit('removeSelectedBreeds', breed.id);
			}
		},
		redirectSendNotification() {
			if (this.selectedBreeds.length === 0) {
				this.showCustomInfoToast('Please select breed first.');
				return;
			}

			this.$router.push('notifications/send?fromBreeds=true');
		},
		clearSelected() {
			this.$store.commit('clearSelectedBreeds');
		},
		setCheckedValue(breed) {
			const isIncluded = this.selectedBreeds.find(sb => sb.id === breed.id);
			return isIncluded ? true : false;
		}
	}
}